import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { typeToConstructor } from "./typeToConstructor.mjs";
/**
 * @description takes an input map of the form `{ [string]: string | Constructor }` and returns a map of `{ [string]: Constructor }`
 */

export function mapToTypeMap(registry, input) {
  return Object.entries(input).reduce(function (output, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        type = _ref2[1];

    output[key] = typeToConstructor(registry, type);
    return output;
  }, {});
}